import { Controller } from "stimulus"

export default class extends Controller {
  static values = {
    launchUrl: String,
    lmsCommitUrl: String
  }

  connect() {
    this.terminating = false
    this.finished = false

    const Scorm12API = window.Scorm12API
    if (typeof Scorm12API !== "function") {
      console.error("[scorm] Scorm12API missing — CDN script failed to load")
      return
    }

    window.API = new Scorm12API({
      autocommit: true,
      autocommitSeconds: 30,
      mastery_override: true,
      logLevel: 4,
      lmsCommitUrl: this.lmsCommitUrlValue,
      asyncCommit: true,
      alwaysSendTotalTime: true,
      requestHandler: data => ({ ...data, terminate: this.terminating }),
      responseHandler: async response => response.json()
    })

    window.API.on("CommitError", (...args) =>
      console.error("[scorm] CommitError", ...args)
    )
    window.API.on("BeforeTerminate", () => {
      this.terminating = true
    })

    const iframe = document.createElement("iframe")
    iframe.src = this.launchUrlValue
    iframe.className = "scorm-player__iframe"
    iframe.allow = "fullscreen"
    iframe.setAttribute("title", "SCORM course content")
    this.element.appendChild(iframe)
    this.iframe = iframe

    this.boundFinish = () => this.finish()
    window.addEventListener("pagehide", this.boundFinish)
  }

  disconnect() {
    window.removeEventListener("pagehide", this.boundFinish)
    this.finish()
    delete window.API
    this.iframe?.remove()
  }

  finish() {
    if (this.finished) return
    this.finished = true

    if (window.API && typeof window.API.LMSFinish === "function") {
      this.terminating = true
      window.API.LMSFinish("")
    }
  }
}
